module.exports = __webpack_public_path__ + "img/contact.3d7072f6.png";